export const RESEND_EMAIL_DELAY = 30;
